export const styledTableHead = {
  backgroundColor: 'var(--bg-surface)',
  color: 'var(--text-primary)',
  fontFamily: 'Poppins, sans-serif',
  fontSize: '15px',
  lineHeight: '20px',
  fontWeight: '500 !important',
  padding: '14px 10px 14px 10px',
};

export const styledTableBody = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: '14px',
  color: 'var(--text-primary)',
  lineHeight: '20px',
  fontWeight: '400',
  padding: '8px 10px 8px 10px',
  wordBreak: 'break-all',
};

export const styledTableRow = {
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  '&:hover': {
    background: 'var(--bg-subtle)',
  },
};

export const tableContainer = {
  border: '1px solid var(--border)',
  borderRadius: '16px',
  boxShadow: 'none',
  height: '100%',
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'var(--border)',
    borderRadius: '100px',
  },
  // На телефоне колонки нельзя ужимать — таблица становится нечитаемой.
  // Даём ей минимальную ширину и горизонтальный скролл с инерцией.
  '@media (max-width: 767px)': {
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    '& table': {
      minWidth: '760px',
    },
  },
};

export const tableHeadCell = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',
};
